"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uiReducer = uiReducer;
var _types = require("./types");
var _types2 = require("../game/types");
var _types3 = require("../bet/types");
var _DialogState = require("../../../ui/enums/DialogState");
var initialState = {
  dialogState: _DialogState.DialogState.CLOSED,
  promptState: _types.PromptState.Hide,
  idleText: undefined,
  statusText: {
    value: undefined,
    attract: undefined
  },
  //TEMP
  showSpinButton: true,
  showStopButton: true
};
function uiReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _types.STATUS_TEXT_STATE:
      return Object.assign({}, state, {
        statusTextState: action.payload
      });
    case _types.STATUS_TEXT_SET:
      return Object.assign({}, state, {
        statusText: {
          value: action.payload.value,
          attract: action.payload.attract
        }
      });
    case _types.STATUS_TEXT_CLEAR:
      {
        return Object.assign({}, state, {
          statusText: {
            value: null,
            attract: null
          }
        });
      }
    case _types.DIALOG_STATE:
      {
        var newState = Object.assign({}, state);
        newState.dialogState = action.payload;
        return newState;
      }
    case _types.DIALOG_CLOSE:
      {
        var _newState = Object.assign({}, state);
        _newState.dialogState = _DialogState.DialogState.CLOSED;
        _newState.pendingServerResponse = false;
        return _newState;
      }
    case _types.ORIENTATION_BLOCK:
      {
        var _newState2 = Object.assign({}, state);
        _newState2.orientationBlock = action.payload;
        return _newState2;
      }
    case _types.PROMPT_SET_STATE:
      {
        return Object.assign({}, state, {
          promptState: action.payload
        });
      }
    case _types.SET_DIALOG_CUSTOM_TEXT:
      {
        return Object.assign({}, state, {
          dialogCustomHeader: action.payload.header,
          dialogCustomContent: action.payload.content
        });
      }
    case _types.SET_DIALOG_CUSTOM_ACTIONS:
      {
        return Object.assign({}, state, {
          dialogCustomActions: action.payload
        });
      }
    case _types.SET_IDLE_TEXT:
      {
        return Object.assign({}, state, {
          idleText: {
            value: action.payload ? action.payload.value : undefined,
            attract: action.payload ? action.payload.attract : undefined
          }
        });
      }
    case _types2.ROUND_START:
      {
        return Object.assign({}, state, {
          idleText: undefined
        });
      }
    /** this was done for swipies. it fucks alot of thing up for mobile ui and the */
    case _types3.UPDATE_BET:
      {
        return Object.assign({}, state, {
          idleText: undefined,
          statusText: {
            attract: undefined,
            value: ""
          }
        });
      }
    /**     case AUTO_PLAY: {
            return Object.assign<UIState, UIState, UIState>({}, state, {
                showSpinButton: false
            })
        }*/
    case _types2.EXITING:
    case _types.HIDE_SPIN_BUTTON:
      {
        return Object.assign({}, state, {
          showSpinButton: false
        });
      }
    case _types.SHOW_SPIN_BUTTON:
      {
        return Object.assign({}, state, {
          showSpinButton: true
        });
      }
    case _types.TIMER_START:
      {
        return Object.assign({}, state, {
          durationTimer: action.payload
        });
      }
    case _types.TIMER_CLEAR:
      {
        return Object.assign({}, state, {
          durationTimer: null
        });
      }
    case _types.TIMER_TICK:
      {
        return Object.assign({}, state, {
          valueTimer: action.payload
        });
      }
    case _types.SET_DIALOG_ACTIONS:
      {
        return Object.assign({}, state, {
          dialogActions: action.payload
        });
      }
    case _types.RESET_DIALOG_ACTIONS:
      {
        return Object.assign({}, state, {
          dialogActions: null
        });
      }
    case _types.PENDING_SERVER_RESPONSE:
      {
        return Object.assign({}, state, {
          pendingServerResponse: true
        });
      }
    // make game info work properly on reconnects.
    case _types2.UNFINISHED_FEATURE:
      {
        return Object.assign({}, state, {
          statusTextState: _types.StatusTextState.Running
        });
      }
    case _types.SET_PROMO_GAME_TEXT:
      {
        return Object.assign({}, state, {
          promoGameText: action.payload
        });
      }
  }
  return state;
}
//# sourceMappingURL=reducer.js.map